import { createFileRoute } from "@tanstack/react-router";
import CarmaxHome from "@/components/carmax/CarmaxHome";

// Test-only build of the new shopper-first homepage. Live "/" is untouched.
export const Route = createFileRoute("/preview/home")({
  head: () => ({
    meta: [
      { title: "New Homepage Preview | Rex & Sons RVs" },
      { name: "description", content: "Test layout of the new Rex & Sons RVs homepage." },
      { property: "og:title", content: "New Homepage Preview | Rex & Sons RVs" },
      { property: "og:description", content: "Test layout of the new Rex & Sons RVs homepage." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CarmaxHome,
});
